import { cn } from "@papier/ui/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-2xl bg-muted/50", className)}
      {...props}
    />
  );
}

export { Skeleton };
